import React, { useState, useEffect, useRef } from 'react';

import Tag from '../components/Tag';
import Button from '../components/Button';

import Headerbar from './Headerbar'

function Olympus(props) {
  const bannerRef = useRef(null);
  const [height, setHeight] = useState(0);

  const Row = (props) => {
    return(<div className='border-t-[1px] border-blue p-[0.5rem] w-full h-fit keplersemi flex flex-row space-x-[0.5rem]'>
      {props.children}
    </div>)
  }

  useEffect(() => {
    const bannerHeight = () => {
      if (bannerRef.current && bannerRef.current.getBoundingClientRect().height !== height) {
        let h = bannerRef.current.getBoundingClientRect().height;
        setHeight(h)
      }
    }

    bannerHeight();
    window.addEventListener('resize', bannerHeight);
    setInterval(()=>{
      bannerHeight();
    }, 500)

    return () => {
      window.removeEventListener('resize', bannerHeight);
    }
  }, []);

    return (
      <div className='relative w-full flex flex-col justify-start items-center min-h-[840px] h-full text-blue pt-[4.5rem]'
      onMouseEnter={() => props.setHover({})}>
      <div className='flex my-auto w-full h-fit lg:max-h-[1000px] p-[1.5rem] md:p-[3rem] xl:px-[6rem] relative z-0 max-w-[2000px]'>
        <div className='min-h-fit h-full w-full flex flex-col md:flex-row items-start justify-start pb-[2rem] md:pb-0'>
          <div id='Banner' ref={bannerRef} className='w-full lg:w-1/2 xl:w-1/3 3xl:min-w-[500px] h-fit mb-[2rem] md:mb-0 md:mr-[1rem] fadein'>
            <div className='lg:max-w-[800px] driftinfast relative left-0 flex flex-col justify-start items-start h-fit min-h-full'>
              <a className='keplersemi text-blue w-fit inline md:hidden mb-[2rem]' href='/projects'>
              <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>
              
              <div className='w-full min-h-full h-fit flex flex-col justify-start space-y-[1rem]'>
                <div>
                  <img className='mb-[1rem] w-[100%] h-auto max-w-[400px]' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/
                  .png' 
                  alt='olympus'/>
                  <div className='flex w-full h-fit py-[0.5rem] justify-start flex-wrap'>
                    <Tag text={'Branding'}/>
                    <Tag text={'Web Design'}/>
                    <Tag text={'UI/UX Design'}/>
                    <Tag text={'Website Development'}/>
                    <Tag text={'App Development'}/>
                  </div>
                </div>

                <div className='w-full flex justify-start items-start'>
                  <p className='min-w-[300px] text-start'>
                  <mark>Olympus</mark> is a <mark>social weightlifting app</mark> that provides <mark>flexible workout tracking and analytics.</mark> It was founded in the Northwestern University entrepreneurship community, the Garage, in 2022. 
                  I joined the team when the startup was in its early stages, creating its <mark>visual brand</mark> and applying this aesthetic to a <mark>React landing page and app UI</mark> on Figma.<br/><br/>
                  Throughout my work I honed my foundational design skills by speaking with experienced UI designers, learning from user feedback and website analytics, and studying exemplary designs on Dribbble and Behance.
                  Applying these insights, I overhauled my first iteration of the Olympus landing page and began a <mark>component library of standardized UI elements</mark> for future designers.
                  </p>
                </div>

                <div className='w-full text-blue keplersemi'>
                  <div className='flex w-full h-fit pt-0 justify-start items-start flex-col text-blue keplermed'>
                    <Row>
                      <div className='min-w-[8rem]'>DURATION</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>Oct 2022 ~ Aug 2023</p>
                      </div>
                    </Row>
                    <Row>
                      <div className='min-w-[8rem]'>ROLES</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>1) Visual Brand Designer</p>
                        <p>2) Web Designer & Developer</p>
                        <p>3) App Designer & Developer</p>
                      </div>
                    </Row>
                    <Row>
                      <div className='min-w-[8rem]'>SKILLS<br/>DEVELOPED</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>1) Applying design psychology to website layouts</p>
                        <p>2) Creating component libraries on Figma</p>
                        <p>3) App development in React Native</p>
                        <p>4) Brainstorming & planning brand visual identity</p>
                        <p>5) IOS human design guidelines & dark-themed UI design methodology</p>
                        <p>6) Planning user-friendly information architecture</p>
                      </div>
                    </Row>
                  </div>
                </div>
                
                <a className='keplersemi text-blue w-fit hidden md:inline' href='/projects'>
                <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
                </a>
              </div>
            </div>
          </div>

          <div id='scroll' className='relative w-full lg:w-1/2 xl:w-2/3 3xl:w-full flex flex-row z-0 justify-start items-start pb-[2rem] md:pb-[1rem] md:pl-[1rem]' 
            style={{height: (window.innerWidth > 768) ? height : 'fit'}}>
            <img className='driftinleft hidden md:inline absolute -z-10 w-[100%] h-[100%] object-cover right-[1.5rem] top-[1rem] pl-[1.5rem] pb-[1rem] opacity-50' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/sand.png' 
            alt='sand background'/>

            <div className='w-full h-fit md:h-full flex flex-col space-y-[0.5rem] justify-start items-start md:overflow-y-scroll'>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  BRAINSTORMING
                </div>
              </div>
              <div className='flex flex-wrap justify-start items-start'>
                <img className='w-full sm:w-1/2 h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/brainstorm_1.png' 
                alt='brand brainstorming 1'/>
                <img className='w-full sm:w-1/2 h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/brainstorm_6.png' 
                alt='brand brainstorming 2'/>
                <img className='w-full sm:w-1/2 h-auto object-contain'src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/brainstorm_3.png'
                alt='brand brainstorming 3'/>
                <img className='w-full sm:w-1/2 h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/brainstorm_2.png' 
                alt='brand brainstorming 4'/>
              </div>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  VISUAL IDENTITY
                </div>
              </div>
              <div className='w-full flex flex-col sm:flex-row justify-start items-start'>
                <img className='w-full sm:w-2/3 object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/brainstorm_4.png' 
                alt='olympus visual identity 1'/>
                <img className='w-full sm:w-1/3 object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/brainstorm_5.png' 
                alt='olympus visual identity 2'/>
              </div>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/brainstorm_7.png'  
              alt='olympus logo'/>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  LANDING PAGE
                </div>
              </div>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/website_1.png' 
              alt='olympus website screenshot'/>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/website_2.png' 
              alt='olympus website screenshot'/>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/website_3.png' 
              alt='olympus website screenshot'/>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/website_4.png' 
              alt='olympus website screenshot'/>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  FIGMA COMPONENT LIBRARY
                </div>
              </div>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/wireframe_1.png'
              alt='olympus component library'/>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  SCREEN MOCKUPS
                </div>
              </div>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/wireframe_2.png'
              alt='olympus wireframes 1'/>
              <img className='w-full h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/wireframe_3.png'
              alt='olympus wireframes 2'/>
              <img className='w-4/5 h-auto object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/olympus/wireframe_4.png'
              alt='olympus wireframes 3'/>

              <a className='keplersemi text-blue w-fit lg:hidden my-[2rem]' href='/projects'>
              <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Headerbar {... props}/>
    </div> );
}

export default Olympus;